// apiConfig.js
const API_CONFIG = {
    apiUrl: 'https://api.azyekoslounges.net/',
  };
  
  export default API_CONFIG;
  